export enum TextAlign {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

export const labels = {
  [TextAlign.Left]: 'Left',
  [TextAlign.Center]: 'Center',
  [TextAlign.Right]: 'Right',
}
